module.exports = __webpack_public_path__ + "static/media/buildingConstruction38.a71cd2b5.jpg";